import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  pageAlert: {
    '& .MuiGrid-spacing-xs-2': {
      margin: '-9px 0 10px 0',
    },
    '& svg': {
      top: 21,
      right: 21,
    },
  },
}));
